<div [dialogRef]="dialog" (appClickOutside)="close()">
  <kendo-dialog-titlebar (close)="close()">
    <div class="modal-title">
      <div class="ml-16">
        <span>Update Scene Status</span>
        <p class="secondary mb-0">ID: {{this.data?.nefcoNumber}}</p>
      </div>
    </div>
  </kendo-dialog-titlebar>
  <section>
    <p class="mb-16">Add a comment and select if you want to reactivate the investigation or keep the investigation as closed.</p>
    <form #commentForm="ngForm">
      <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(1,minmax(0,1fr))']">
        <kendo-gridlayout-item>
          <kendo-formfield>
            <kendo-label class="asterisk" text="Comment"></kendo-label>
            <kendo-textarea name="commentName" #commentName="ngModel" [(ngModel)]="comment" placeholder="Enter Comment"
              fillMode="outline" class="min-height-96" resizable="both" [required]="true"
              appNoWhiteSpace></kendo-textarea>
            <kendo-formerror *ngIf="commentName?.errors">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              <span *ngIf="commentName?.errors.required">Comment cannot be left blank</span>
            </kendo-formerror>
          </kendo-formfield>
        </kendo-gridlayout-item>
      </kendo-gridlayout>
    </form>
  </section>
  <kendo-dialog-actions layout="end" class="p-24">
    <button kendoButton [size]="'medium'" themeColor="light" (click)="addComment(false)">
      Add comment & Keep Closed
    </button>
    <button kendoButton [size]="'medium'"  themeColor="primary" class="ml-12"
      (click)="addComment(true)">
      Add Comment & Reactivate
    </button>
  </kendo-dialog-actions>
</div>